export const removeKey = (key: string, { [key]: _, ...rest }) => rest;
